// Lib
import { curry } from 'lodash/fp';

// Utils
import { roundToStep as roundToS } from '../roundToStep';
import * as geometryUtils from './geometryUtils';
import { getX, getY } from './dimensionUtil';

export const getPoint = (x, y) => ({ x, y });

export const { scale, reverseScale } = geometryUtils;
export const round = geometryUtils.roundVals;
export const roundUp = geometryUtils.roundUpVals;
export const roundToStep = (step, point) => ({
    x: roundToS(getX(point), step),
    y: roundToS(getY(point), step),
});

export const getDistanceSquared = (point1, point2) => {
    const xd = getX(point1) - getX(point2);
    const yd = getY(point1) - getY(point2);
    return xd * xd + yd * yd;
};

export const getDistance = (point1, point2) => Math.sqrt(getDistanceSquared(point1, point2));

export const getArePointsClose = (point1, point2, closeDistance) => {
    if (!point1 || !point2) return false;

    const distSq = getDistanceSquared(point1, point2);

    return distSq < closeDistance * closeDistance;
};

export const equals = (point1, point2) => point1.x === point2.x && point1.y === point2.y;

export const getAngleBetween = (point1, point2) => Math.atan2(point2.y - point1.y, point2.x - point1.x);

export const translate = curry((translationPoint, point) =>
    getPoint(getX(point) + getX(translationPoint), getY(point) + getY(translationPoint)),
);

export const difference = curry((translationPoint, point) =>
    getPoint(getX(point) - getX(translationPoint), getY(point) - getY(translationPoint)),
);
export const reverseTranslate = difference;

export const getVectorMagnitude = (point) => Math.sqrt(point.x * point.x + point.y * point.y);

export const asPoint = (obj) => {
    if (!obj) return obj;

    return { x: getX(obj), y: getY(obj) };
};
